import { useReducer } from 'react';
import { SECTION_TYPE } from 'components/newAccountSteps/initialStep/constants';

const { PERSONAL_DATA, PRECONTRACTUAL_DOCS, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;

export const INITIAL_STATE = {
    [PERSONAL_DATA]: {
        isValidated: false,
        isCollapsed: false,
    },
    [PRECONTRACTUAL_DOCS]: {
        isValidated: false,
        isCollapsed: true,
    },
    [EMAIL_OTP_VALIDATION]: {
        isValidated: false,
        isCollapsed: true,
    },
    [ACCESS_DATA]: {
        isValidated: false,
        isCollapsed: true,
    },
};

const actions = {
    VALIDATE_SECTION: 'VALIDATE_SECTION',
    MODIFY_SECTION: 'MODIFY_SECTION',
    RESET_SECTION: 'RESET_SECTION',
};

const reducer = (state, action) => {
    const checkNextSectionToOpen = () => {
        const actualSection = action.payload.section;

        return Object.keys(state).find(sectionKey => {
            const sectionData = state[sectionKey];

            return !sectionData.isValidated && sectionKey !== actualSection;
        });
    };

    switch (action.type) {
        case actions.VALIDATE_SECTION: {
            const actualSection = action.payload.section;
            const nextSectionToOpen = checkNextSectionToOpen();

            return {
                ...state,
                [actualSection]: { ...state[actualSection], isCollapsed: true, isValidated: true },
                ...(nextSectionToOpen && { [nextSectionToOpen]: { ...state[nextSectionToOpen], isCollapsed: false } }),
            };
        }
        case actions.MODIFY_SECTION: {
            const sections = Object.keys(INITIAL_STATE);

            return sections.reduce((newState, section) => {
                newState[section] = { ...state[section], isCollapsed: section !== action.payload.section };

                return newState;
            }, {});
        }
        case actions.RESET_SECTION: {
            const actualSection = action.payload.section;

            return { ...state, [actualSection]: INITIAL_STATE[actualSection] };
        }
        default:
            throw new Error();
    }
};

export const useSections = initialState => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const validatePersonalDataSection = () => {
        dispatch({ type: actions.VALIDATE_SECTION, payload: { section: PERSONAL_DATA } });
    };
    const validatePrecontractualDocsSection = () => {
        dispatch({ type: actions.VALIDATE_SECTION, payload: { section: PRECONTRACTUAL_DOCS } });
    };
    const validateOTPValidationSection = () => {
        dispatch({ type: actions.VALIDATE_SECTION, payload: { section: EMAIL_OTP_VALIDATION } });
    };
    const validateAccessDataSection = () => {
        dispatch({ type: actions.VALIDATE_SECTION, payload: { section: ACCESS_DATA } });
    };
    const modifyPersonalDataSection = () => {
        dispatch({ type: actions.MODIFY_SECTION, payload: { section: PERSONAL_DATA } });
    };
    const modifyPrecontractualDocsSection = () => {
        dispatch({ type: actions.MODIFY_SECTION, payload: { section: PRECONTRACTUAL_DOCS } });
    };
    const modifyEmailOTPSection = () => {
        dispatch({ type: actions.MODIFY_SECTION, payload: { section: EMAIL_OTP_VALIDATION } });
    };
    const modifyAccessDataSection = () => {
        dispatch({ type: actions.MODIFY_SECTION, payload: { section: ACCESS_DATA } });
    };
    const resetPersonalDataSection = () => {
        dispatch({ type: actions.RESET_SECTION, payload: { section: PERSONAL_DATA } });
    };
    const resetPrecontractualDocsSection = () => {
        dispatch({ type: actions.RESET_SECTION, payload: { section: PRECONTRACTUAL_DOCS } });
    };
    const resetEmailOTPSection = () => {
        dispatch({ type: actions.RESET_SECTION, payload: { section: EMAIL_OTP_VALIDATION } });
    };
    const resetAccessDataSection = () => {
        dispatch({ type: actions.RESET_SECTION, payload: { section: ACCESS_DATA } });
    };

    return {
        state,
        validatePersonalDataSection,
        validatePrecontractualDocsSection,
        validateOTPValidationSection,
        validateAccessDataSection,
        modifyPersonalDataSection,
        modifyPrecontractualDocsSection,
        modifyEmailOTPSection,
        modifyAccessDataSection,
        resetPersonalDataSection,
        resetPrecontractualDocsSection,
        resetEmailOTPSection,
        resetAccessDataSection,
    };
};
